import { Container } from "@wisr/react-ui";
import React from "react";

import { LayoutType } from "../application-layout.utils";
import footerStyle from "./footer.scss";
import { AwardsWidget } from "../../../awards/awards-widget";
import { LoanOfferFooter } from "./loan-offer-footer/loan-offer-footer";

interface Props {
  layoutType: LayoutType;
}

export const FooterComponent: React.FC<Props> = (props) => {
  const { layoutType } = props;

  if (layoutType === "multi-page-form") {
    return (
      <footer>
        <style jsx>{footerStyle}</style>
        <Container>
          <AwardsWidget location="footer"></AwardsWidget>
        </Container>
      </footer>
    );
  }

  return <LoanOfferFooter />;
};
